// The signed-in session: one bearer token in the host's storage.
import { getConfig } from "./config";

export const TOKEN_KEY = "token";
// FX cache keys live here too so logout can drop them with the token.
export const RATES_CACHE_KEY = "exchangeRates";
export const RATES_TS_KEY = "exchangeRatesTimestamp";

export const getToken = () => getConfig().storage.getItem(TOKEN_KEY);
export const setToken = (token) => getConfig().storage.setItem(TOKEN_KEY, token);

/** Forget the session and anything cached for the previous account. */
export function clearSession() {
  const { storage } = getConfig();
  storage.removeItem(TOKEN_KEY);
  storage.removeItem(RATES_CACHE_KEY);
  storage.removeItem(RATES_TS_KEY);
}
